import React, { useState} from "react";
import Style from "./LiveLocation.module.css";
import LiveLocationMap from "../../Component/LiveLocationMap/LiveLocationMap";
import BurgerMenuTitle from "../../Component/BurgerMenuTitle/BurgerMenuTitle";
import { useEffect } from "react";
import { getDeliverInfoApi } from "../../Api/ClientServices";
import { errorToast } from "../../Toast/Toast";

const LiveLocation = (props) => {
  const [data,setData]=useState()
  useEffect(()=>{
    getDeliverInfo()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])
  const getDeliverInfo=async()=>{
    getDeliverInfoApi(props.location.state,(succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          setData(res.delivery)
        }
      }else{
        console.error(res)
      }
    })
  }
  // http://cdn.ir/deliver/photo/${data&&data.photo}.jpg
  return (
    <div className={Style.DivHolder}>
      <BurgerMenuTitle title={"اطلاعات پیک"}/>
      <LiveLocationMap orderId={props.location.state}/>
      <div className={Style.deliverInfoHolder}>
        <div className={Style.deliverInfo}>
          <div className={Style.picHolder}>
            <img src={`//cdn.barest.ir/deliver/photo/${data&&data.photo}.jpg`} alt="مکان یاب"/>
          </div>
          <h2 className={Style.fullName}>{data&&data.full_name}</h2>
        </div>
      </div>
    </div>
  );
};
export default LiveLocation;
